import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteRadiologyPrescriptionMutation as useChDeleteRadiologyPrescriptionMutationType } from "@/modules/patients/detail/meas-radiology-prescription/ch/services/__generated__/useChDeleteRadiologyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChDeleteRadiologyPrescriptionMutation($input: Ch_deleteMeasRadiologyPrescriptionInput!) {
    ch_deleteMeasRadiologyPrescription(input: $input) {
      ch_MeasRadiologyPrescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteRadiologyPrescriptionMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteRadiologyPrescriptionMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteRadiologyPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteRadiologyPrescriptionMutation }
